import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, CircularProgress, List, ListItem, ListItemIcon, Typography } from '@mui/material'
import { useMemo } from 'react'

import { useAppContext } from '@/hooks'

import type { ImportProgress } from '../../../types'

interface ImportProgressContentProps {
	progress: ImportProgress
}

const MAX_DISPLAYED_STEPS = 10

export const ImportProgressContent = ({ progress }: ImportProgressContentProps) => {
	const { t } = useAppContext()

	const displayedSteps = useMemo(
		() => progress.completedSteps.slice(-MAX_DISPLAYED_STEPS),
		[progress.completedSteps],
	)

	return (
		<Box>
			<Box className="flex items-center gap-2 mb-4">
				<CircularProgress size={24} />
				<Typography variant="h6">{t('IMPORT_SQL_UPLOADING')}</Typography>
			</Box>

			{progress.currentStep && (
				<Box className="mb-4">
					<Typography variant="body2" color="text.secondary">
						{t('IMPORT_SQL_CURRENT_STEP')}:
					</Typography>
					<Typography variant="body1" className="font-medium">
						{progress.currentStepDescription || 'Processing...'}
					</Typography>
				</Box>
			)}

			{displayedSteps.length > 0 && (
				<Box>
					<Typography variant="body2" color="text.secondary" className="mb-2">
						{t('IMPORT_SQL_COMPLETED_STEPS')}:
					</Typography>
					<List dense>
						{displayedSteps.map((stepDesc, i) => (
							<ListItem key={i}>
								<ListItemIcon>
									<CheckCircleIcon color="success" fontSize="small" />
								</ListItemIcon>
								<Typography variant="body2">{stepDesc}</Typography>
							</ListItem>
						))}
					</List>
				</Box>
			)}
		</Box>
	)
}

